// extracted by mini-css-extract-plugin
export default {"link":"NavLink_link__2SrjN","active":"NavLink_active__h6+gF"};